<div class="upload-item" #item>
  <div class="upload-preview">
    @if (previewMode === 'gallery') {
      <app-svg src="/assets/icons/gallery-folder.svg"></app-svg>
    }
    @if (previewMode === 'asset') {
      <app-svg src="/assets/icons/image.svg"></app-svg>
    }
    @if (previewMode === 'unknown') {
      <app-svg src="/assets/icons/question.svg"></app-svg>
    }
  </div>
  <div
    class="upload-item-meta"
    [class.error]="upload.status === 'error'"
    [class.warning]="['invalid-file-type', 'cancelled'].includes(upload.error)"
  >
    @if (upload.file) {
      <b appTooltip="{{ upload.file?.name }}">{{ upload.file?.name }}</b>
    }
    @if (!upload.file) {
      <b>Unknown</b>
    }
    @if (upload.status === 'waiting') {
      <span>Waiting to upload · {{ upload.file.size | dataUnitsBigInt }}</span>
    }
    @if (upload.status === 'started') {
      <span>Uploading · {{ upload.file.size | dataUnitsBigInt }}</span>
    }
    @if (upload.status === 'done') {
      <span>Completed</span>
    }
    @if (
      upload.status === 'error' &&
      (upload.error === 'general' ||
        upload.error === 'failed-to-upload' ||
        upload.error === 'failed-to-create-asset' ||
        upload.error === 'resource_missing')
    ) {
      <span>Upload Error · Please try again</span>
    } @else if (upload.status === 'error' && upload.error === 'cant-read-file') {
      <span>Failed to read file from your system · Try again</span>
    } @else if (upload.status === 'error' && upload.error === 'invalid-file-type') {
      <span>Filetype not supported</span>
    } @else if (upload.status === 'error' && upload.error === 'file-too-big') {
      <span>File is too large</span>
    } @else if (upload.status === 'error' && upload.error === 'cancelled') {
      <span>Cancelled</span>
    } @else if (upload.status === 'error' && upload.error === 'wrong-type') {
      <span>File type mismatch</span>
    } @else if (upload.status === 'error' && upload.error === 'unprocessable_entity') {
      <span>Filetype not supported</span>
    } @else if (upload.status === 'error' && upload.error === 'payment_required') {
      <span>Credit limit reached</span>
    }
  </div>
  @if (['started', 'waiting'].includes(upload.status)) {
    <div class="upload-status">
      <app-circle-progress-bar [progress]="upload.progress" [slowTransition]="true"></app-circle-progress-bar>
    </div>
  }
  @if (upload.status === 'done') {
    <div class="upload-status">
      <app-svg src="/assets/icons/check-filled.svg" class="success"></app-svg>
    </div>
  }
  @if (upload.status === 'error') {
    <div class="upload-status" [class.cancellable]="!preventDismiss" (click)="dismissError()">
      @if (upload.error === 'general') {
        <app-svg src="/assets/icons/alert-circle.svg" class="error"></app-svg>
      }
      @if (['invalid-file-type', 'cancelled'].includes(upload.error)) {
        <app-svg src="/assets/icons/alert.svg" class="warn"> </app-svg>
      }
      @if (!preventDismiss) {
        <app-svg src="/assets/icons/cross.svg" class="cancel-icon"></app-svg>
      }
    </div>
  }
</div>
